export default "__VITE_ASSET__13d3d0d0__"